export default __webpack_public_path__ + "static/media/warrantyManagement2.ad03e756.png";